import { createReducer, makeActionCreator } from "util/redux";

export const types = {
    FREQUENT_DESTINATION_PRE_REQUEST: "frequentdestinations/FREQUENT_DESTINATION_PRE_REQUEST",
    FREQUENT_DESTINATION_PRE_REQUEST_SUCCESS: "frequentdestinations/FREQUENT_DESTINATION_PRE_REQUEST_SUCCESS",

    LOAD_LIST_REQUEST: "frequentdestinations/LOAD_LIST_REQUEST",
    LOAD_LIST_FAILURE: "frequentdestinations/LOAD_LIST_FAILURE",
    LOAD_LIST_SUCCESS: "frequentdestinations/LOAD_LIST_SUCCESS",
    LOAD_MORE_REQUEST: "frequentdestinations/LOAD_MORE_REQUEST",
    LOAD_MORE_SUCCESS: "frequentdestinations/LOAD_MORE_SUCCESS",
    LOAD_SINGLE_SUCCESS: "frequentdestinations/LOAD_SINGLE_SUCCESS",

    CREATE_PREVIEW: "frequentDestination/CREATE_PREVIEW",
    CREATE_PREVIEW_FAILED: "frequentDestination/CREATE_PREVIEW_FAILED",
    CREATE_PREVIEW_SUCCESS: "frequentDestination/CREATE_PREVIEW_SUCCESS",
    CREATE_FAILURE: `frequentDestination/CREATE_FAILURE`,
    CREATE_REQUEST: `frequentDestination/CREATE_REQUEST`,
    CREATE_SUCCESS: `frequentDestination/CREATE_SUCCESS`,

    CREATE_DETAIL: `frequentDestination/CREATE_DETAIL`,
    CREATE_DETAIL_SUCCES: `frequentDestination/CREATE_DETAIL_SUCCES`,

    DELETE_REQUEST: `frequentDestination/DELETE_REQUEST`,
    DELETE_FAILURE: `frequentDestination/DELETE_FAILURE`,
    DELETE_SUCCESS: `frequentDestination/DELETE_SUCCESS`,

    MODIFY_REQUEST: `frequentDestination/MODIFY_REQUEST`,
    MODIFY_FAILURE: `frequentDestination/MODIFY_FAILURE`,
    MODIFY_SUCCESS: `frequentDestination/MODIFY_SUCCESS`,
};

export const INITIAL_STATE = {
    list: [],
    pageNumber: 1,
    totalPages: 0,
    hasMoreData: false,
    fetching: true,
    fetchingMoreFrequentDestinations: false,
    filterText: "",
    frequentDestination: {},
    frequentDestionationOnRow: {},
    creditNumberSelected: "",
    defaultCountry: "",
    defaultDocumentType: "",
    countryList: [],
    documentTypeList: [],
};

export default createReducer(INITIAL_STATE, {
    [types.FREQUENT_DESTINATION_PRE_REQUEST]: (state) => ({
        ...state,
    }),

    [types.FREQUENT_DESTINATION_PRE_REQUEST_SUCCESS]: (state, { data }) => ({
        ...state,
        defaultCountry: data.defaultCountry,
        defaultDocumentType: data.documentTypeList.filter(
            (documentType) => documentType.id_country_code === data.defaultCountry,
        )[0].id_document_type,
        countryList: data.countryList,
        documentTypeList: data.documentTypeList,
    }),

    [types.LOAD_LIST_REQUEST]: (state, { pageNumber, filterText }) => ({
        ...state,
        fetching: true,
        pageNumber,
        filterText,
    }),
    [types.LOAD_LIST_FAILURE]: (state) => ({
        ...state,
        fetching: false,
    }),
    [types.LOAD_LIST_SUCCESS]: (state, { data }) => ({
        list: data.frequentDestinations,
        pageNumber: data.pageNumber,
        fetching: false,
    }),

    [types.LOAD_SINGLE_SUCCESS]: (state) => ({
        ...state,
        fetching: false,
    }),

    [types.LOAD_MORE_REQUEST]: (state) => ({
        ...state,
        fetchingMoreFrequentDestinations: true,
    }),
    [types.LOAD_MORE_SUCCESS]: (state, { data }) => ({
        ...state,
        fetchingMoreFrequentDestinations: false,
        list: state.list ? state.list.concat(data.frequentDestinations) : data.list,
        hasMoreData: data.moreStatements,
        pageNumber: data.pageNumber,
    }),

    [types.CREATE_PREVIEW]: (state) => ({
        ...state,
        fetching: true,
    }),

    [types.CREATE_PREVIEW_FAILED]: () => ({
        ...INITIAL_STATE,
        fetching: false,
    }),

    [types.CREATE_PREVIEW_SUCCESS]: (state, { data }) => ({
        ...state,
        fetching: false,
        frequentDestination: data.frequentDestination,
    }),

    [types.CREATE_SUCCESS]: (state) => ({
        ...state,
        fetching: false,
    }),

    [types.CREATE_FAILURE]: () => ({
        ...INITIAL_STATE,
        fetching: false,
    }),

    [types.DELETE_PREVIEW_REQUEST]: (state) => ({
        ...state,
        fetching: true,
    }),

    [types.DELETE_PREVIEW_FAILURE]: (state) => ({
        ...state,
        fetching: false,
    }),

    [types.DELETE_PREVIEW_SUCCESS]: (state) => ({
        ...state,
        fetching: false,
    }),

    [types.DELETE_REQUEST]: (state) => ({
        ...state,
        fetching: true,
    }),

    [types.DELETE_FAILURE]: (state) => ({
        ...state,
        fetching: false,
    }),

    [types.DELETE_SUCCESS]: (state) => ({
        ...state,
        fetching: false,
    }),

    [types.CREATE_DETAIL]: (state, { record }) => ({
        ...state,
        frequentDestionationOnRow: record,
    }),

    [types.CREATE_DETAIL_SUCCES]: (state, { frequentDestionationOnRow }) => ({
        ...state,
        frequentDestionationOnRow,
    }),

    [types.MODIFY_REQUEST]: (state) => ({
        ...state,
        fetching: true,
    }),

    [types.MODIFY_FAILURE]: (state) => ({
        ...state,
        fetching: false,
    }),

    [types.MODIFY_SUCCESS]: (state) => ({
        ...state,
        fetching: false,
    }),
});

export const actions = {
    frequentDestinationPre: makeActionCreator(types.FREQUENT_DESTINATION_PRE_REQUEST),
    loadListRequest: (filters) => ({
        type: types.LOAD_LIST_REQUEST,
        filters,
    }),
    loadMoreRequest: (filters) => ({
        type: types.LOAD_MORE_REQUEST,
        filters,
    }),
    loadListFailure: makeActionCreator(types.LOAD_LIST_FAILURE),
    loadListSuccess: makeActionCreator(types.LOAD_LIST_SUCCESS, "data"),
    loadListMoreSuccess: makeActionCreator(types.LOAD_MORE_SUCCESS, "data"),
    loadSingleSuccess: makeActionCreator(types.LOAD_SINGLE_SUCCESS, "data"),

    createPreview: makeActionCreator(types.CREATE_PREVIEW, "params", "formikBag"),
    createPreviewFailed: makeActionCreator(types.CREATE_PREVIEW_FAILED),
    createPreviewSuccess: makeActionCreator(types.CREATE_PREVIEW_SUCCESS, "data"),
    createRequest: makeActionCreator(types.CREATE_REQUEST, "params", "formikBag"),
    createSuccess: makeActionCreator(types.CREATE_SUCCESS, "data"),
    createFailure: makeActionCreator(types.CREATE_FAILURE),

    createDetail: makeActionCreator(types.CREATE_DETAIL, "record"),
    createDetailSucces: makeActionCreator(types.CREATE_DETAIL_SUCCES, "frequentDestionationOnRow"),

    deleteRequest: makeActionCreator(types.DELETE_REQUEST, "frequentDestionationOnRow"),
    deleteFailure: makeActionCreator(types.DELETE_FAILURE),
    deleteSuccess: makeActionCreator(types.DELETE_SUCCESS, "data"),

    modifyRequest: makeActionCreator(types.MODIFY_REQUEST, "frequentDestination"),
    modifyFailure: makeActionCreator(types.MODIFY_FAILURE),
    modifySuccess: makeActionCreator(types.MODIFY_SUCCESS, "data"),
};

export const selectors = {
    getFrequentDestinations: ({ frequentDestination }) => frequentDestination.list,
    isFetching: ({ frequentDestination }) => frequentDestination.fetching,
    isFetchingMoreFrequentDestinations: ({ frequentDestination }) =>
        frequentDestination.fetchingMoreFrequentDestinations,
    getPageNumber: ({ frequentDestination }) => frequentDestination.pageNumber,
    getFilterText: ({ frequentDestination }) => frequentDestination.filterText,
    getTotalPages: ({ frequentDestination }) => frequentDestination.totalPages,
    getHasMoreData: ({ frequentDestination }) => frequentDestination.hasMoreData,
    getFrequentDestination: ({ frequentDestination }) => frequentDestination.frequentDestination,
    getFrequentDestionationOnRow: ({ frequentDestination }) => frequentDestination.frequentDestionationOnRow,
    getCreditNumberSelected: ({ frequentDestination }) => frequentDestination.creditNumberSelected,
    getCountryList: ({ frequentDestination }) => frequentDestination.countryList,
    getDocumentTypeList: ({ frequentDestination }) => frequentDestination.documentTypeList,
    getDefaultCountry: ({ frequentDestination }) => frequentDestination.defaultCountry,
    getDefaultDocumentType: ({ frequentDestination }) => frequentDestination.defaultDocumentType,
};
